module.exports = __webpack_public_path__ + "static/media/CIELlogo-1.ede32d38.png";